export default __webpack_public_path__ + "static/media/banner1.d3a2457f.jpg";